import React from "react";
import Input from "components/base/Input";
import useGetData from "hooks/api/useGetData";
import styles from "../styles.module.scss";
import errorMessage from "constants/errorMessage";
import { useFormContext, UseFormReturn } from "react-hook-form";
import createRegExpFromString from "utils/createRegExpFromString";
import { useTranslation } from "react-i18next";

const SchoolFields = () => {
  const { drawerData } = useGetData();
  type FormType = UseFormReturn<any> & { formState: { isValid: boolean; errors: any } };
  const {
    register,
    formState: { errors }
  }: FormType = useFormContext();
  const { t,  i18n } = useTranslation();

  if (!drawerData?.customer) return null;

  return (
    <>
      <div className={`${styles.firstHeaderSchool} `} data-testid="heading-one">
        {drawerData?.store?.name}
      </div>
      <div className={`${styles.secondHeaderSchool} `} data-testid="heading-two">
        {drawerData?.name}
      </div>

      {drawerData.customer.filter((field) => field?.editable).map(
        (field) =>
          field && (
            <div className={`${styles.fieldWrapper} ${styles.schoolInputWrapper}`} key={field.name}>
              <Input
                id={field.name}
                dataTestId={field.name}
                message={errors[field.name]?.message}
                mandatory={field.mandatory}
                error={!!errors[field.name]}
                defaultValue={field?.value}
                label={field?.label?.find((l) => l.lang === i18n.language)?.text}
                placeholder={field?.description?.find((l) => l.lang === i18n.language)?.text}
                disabled={!field?.editable || false  }
                {...register(field.name, {
                  required: {
                    value: field?.mandatory || false,
                    message: t("firstScreen.requiredInput")
                  },
                  pattern: {
                    value: createRegExpFromString(field?.regex || ""),
                    message: errorMessage.PATTERN
                  }
                })}
                labelClassName={styles.customSchoolLabel}
              />
            </div>
          )
        )
        }
    </>
  );
};

export default SchoolFields;
